import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Option } from 'funfix-core';
import { PureComponent } from 'react';
import FlagsAPI from '../../../services/FlagsAPI';
export default class ConnectFlagWrapper extends PureComponent {
  constructor() {
    super(...arguments);
    _defineProperty(this, "processAction", event => {
      Option.of(this.props.flag.actions.find(action => action.id === event.actionIdentifier)).forEach(action => this.props.onAction(action, this.props.flag));
    });
    _defineProperty(this, "processClose", event => {
      if (this.state.apFlag && this.state.apFlag._id === event.flagIdentifier) {
        this.setState({
          apFlag: null
        });
        this.props.onDismissed(this.props.flag.key);
      }
    });
  }
  componentDidMount() {
    this.setState({
      apFlag: FlagsAPI.createFlag(this.props.flag)
    });
    FlagsAPI.addFlagEventListeners(this.processAction, this.processClose);
  }
  componentWillUnmount() {
    if (this.state.apFlag) {
      this.state.apFlag.close();
    }
    FlagsAPI.removeFlagEventListeners(this.processAction, this.processClose);
  }
  render() {
    return null;
  }
}